
export const baseEmail = ({ content, extraCss = "" }) => `
<!DOCTYPE html>
<html>
    <head>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <style>

            body {margin: 0; padding: 0; font-family: Tahoma, sans-serif;}

            @media only screen and (max-width: 600px) {

                .td-stack-logo {
                    display: block !important;
                    width: 100% !important;    
                    margin: 0 !important;
                    padding: 15px 0 0 0 !important;
                    text-align: center !important;
                }

                .td-stack-text {
                    display: block !important;
                    width: 100% !important;    
                    margin: 0 !important;
                    padding: 5px 0 10px 0 !important;
                }

                .td-stack-text-winners {
                    text-align: center !important;
                    font-size: 20px !important;
                }

                .td-stack-text-agents {
                    padding: 10px 0 10px 0 !important;
                    font-size: 12px !important;
                    text-align: center !important;
                }

                .img-stack {
                    display: inline-block !important;
                    margin: 0 auto !important;
                }
                
                /* CSS adicional do conteúdo */
                ${extraCss}

            }

        </style>
    </head>

    <body>
    <!-- Header -->
    <table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color: #DCDCDC; border-radius: 8px 8px 0 0;">
        <tr>
            <td class="td-stack-logo" width="50%" style="padding: 20px 0 20px 0; vertical-align: middle;" align="right"><img class="img-stack" src="https://firebasestorage.googleapis.com/v0/b/winners-ai-473119.firebasestorage.app/o/logo.png?alt=media&token=c2e27f70-4560-4a33-8e9c-54bc9db93e28" style="display: block; margin: 0; border: 0;" width="120" /></td>
            <td class="td-stack-text" width="50%" style="padding: 0; vertical-align: middle;">
                <table cellpadding="0" cellspacing="0" border="0" width="100%">
                    <tr><td width="100%" class="td-stack-text-winners" style="font-size: 30px; color: #2A5056; font-weight: bold; text-decoration: none; pointer-events: none;">winners&#8203;-&#8203;ai&#8203;.&#8203;com</td></tr>
                    <tr><td width="100%" class="td-stack-text-agents" style="padding-left: 50px; font-size: 18px; color: #515151; font-weight: bold; letter-spacing: 4px;">AGENTES</td></tr>
                </table>
            </td>
        </tr>
    </table>

    <!-- Conteúdo dinâmico -->
    <div style="background-color: #D1ECEE">${content}</div>

    <!-- Rodapé -->
    <table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color: #DCDCDC; border-radius: 0 0 8px 8px;">
        <tr>
            <td style="text-align: center; padding: 15px; font-size: 14px; color:#555;"><p>Não responda este e-mail — ele é enviado de forma automática.</p><p>© 2025 Todos os direitos reservados a <a href="https://www.winners-ai.com" style="color:#2A5056;text-decoration:none;">www.winners-ai.com</a></p></td>
        </tr>
    </table>
    </body>
</html>
`;
